import PropTypes from 'prop-types';
import React from 'react';
import { t } from '../../../../modules/infra/i18n';
import CheckboxSwitch from '../../../common/checkboxSwitch';
import AdminSaveButton from '../../shared/Buttons/AdminSaveButton';

const BrandSubscriptionOptions = ({ handleSubmit, submitting }) => (
  <form onSubmit={handleSubmit} className="u-mb">
    <h5 className="u-mt u-mb-">{t('subscription:enabled_features_heading')}</h5>
    <div className="layout u-mt">
      <CheckboxSwitch name="campaignsEnabled" label={t('subscription:form.engage')} id="campaignsEnabled" wrapperClass="layout__item u-1/2" />
      <CheckboxSwitch name="commissionReportingEnabled" label={t('subscription:form.commission_reports')} id="commissionReportingEnabled" wrapperClass="layout__item u-1/2" />
      <CheckboxSwitch name="productReportingEnabled" label={t('subscription:form.product_reports')} id="productReportingEnabled" wrapperClass="layout__item u-1/2" />
      <CheckboxSwitch name="customReportingEnabled" label={t('subscription:form.custom_reports_enterprise')} id="customReportingEnabled" wrapperClass="layout__item u-1/2" />
      <CheckboxSwitch name="chatEnabled" label={t('subscription:form.chat')} id="chatEnabled" wrapperClass="layout__item u-1/2" />
      <CheckboxSwitch name="conversionTracking" label={t('subscription:form.conversion_tracking')} id="conversionTracking" wrapperClass="layout__item u-1/2" />
      <div className='layout__item'>
        <AdminSaveButton disabled={submitting} content={t('brand:form.save_button')} />
      </div>
    </div>
  </form>
);

BrandSubscriptionOptions.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
};

export default BrandSubscriptionOptions;
